window.ACF_RETARGET_CONFIG = {
  "version": "lf-pdp-v1-20261103",
  "currency": "USD",
  "enabled": false,
  "approvals": {
    "pricing": true,
    "warehouse": false,
    "integrationSeparation": false,
    "checkout": false
  },
  "packs": {
    "3": {
      "comparisonPriceCents": 18900,
      "handle": "miami-md-lift-firm-cream",
      "productId": 8379849441565,
      "variantId": 45147034943773,
      "sku": "MMADLFC-3 - Upsell",
      "price": 12900,
      "fulfillmentVerified": false,
      "subscription": {
        "handle": "miami-md-lift-firm-cream",
        "variantId": 45147034943773,
        "planId": null /* filled from LFQ1103_PLAN_IDS["3"] in lfq1103-native-config.js */,
        "price": 10300,
        "interval": "MONTH",
        "intervalCount": 3,
        "policyVerified": true,
        "evidence": "Public allocation read back 2026-11-03: the pack 3 plan in LFQ1103_PLAN_IDS at 10300 cents, 3-month (build/walk/readback.json)"
      }
    },
    "6": {
      "comparisonPriceCents": 41400,
      "handle": "miamimd-lift-firm-cream-6-jars",
      "productId": 8377795445021,
      "variantId": 45139815956765,
      "sku": "MMADLFC-6 - Upsell",
      "price": 24000,
      "fulfillmentVerified": false,
      "subscription": {
        "handle": "miamimd-lift-firm-cream-6-jars",
        "variantId": 45139815956765,
        "planId": null /* filled from LFQ1103_PLAN_IDS["6"] in lfq1103-native-config.js */,
        "price": 19200,
        "interval": "MONTH",
        "intervalCount": 6,
        "policyVerified": true,
        "evidence": "Public allocation read back 2026-11-03: the pack 6 plan in LFQ1103_PLAN_IDS at 19200 cents, 6-month (build/walk/readback.json)"
      }
    },
    "1": {
      "comparisonPriceCents": 6900,
      "handle": "miami-md-lift-firm-cream-3-jars",
      "productId": 8379855470877,
      "variantId": 45147044118813,
      "sku": "MMADLFC-1 - Upsell",
      "price": 4900,
      "fulfillmentVerified": false,
      "subscription": {
        "handle": "miami-md-lift-firm-cream-3-jars",
        "variantId": 45147044118813,
        "planId": null /* filled from LFQ1103_PLAN_IDS["1"] in lfq1103-native-config.js */,
        "price": 3900,
        "interval": "MONTH",
        "intervalCount": 1,
        "policyVerified": true,
        "evidence": "Public allocation read back 2026-11-03: the pack 1 plan in LFQ1103_PLAN_IDS at 3900 cents, 1-month (build/walk/readback.json)"
      }
    }
  },
  "addons": [
    {
      "handle": "miamimd-instant-wrinkle-eraser-1-bottle-special",
      "productId": 15485379182877,
      "variantId": 67912012398877,
      "sku": "MMIWE-1B",
      "title": "MiamiMD Instant Wrinkle Eraser 1 Bottle (Special)",
      "image": "assets/acfup-iwe.png",
      "price": 3300,
      "catalogPriceCents": 3300,
      "catalogFamily": "special",
      "enabled": false,
      "fulfillmentVerified": false,
      "publicPlanReadbackVerified": false,
      "pricingApproved": true
    },
    {
      "handle": "miamimd-total-beauty-matrix-1-jar-special",
      "productId": 15485392257309,
      "variantId": 67912160608541,
      "sku": "MMTBM-1B",
      "title": "MiamiMD Total Beauty Matrix 1 Jar (Special)",
      "image": "assets/acfup-tbm.png",
      "price": null,
      "catalogPriceCents": 3300,
      "catalogFamily": "special",
      "enabled": false,
      "fulfillmentVerified": false,
      "publicPlanReadbackVerified": false
    },
    {
      "handle": "miamimd-facial-cleanser-1-tube-special",
      "productId": 15485375807773,
      "variantId": 67911977369885,
      "sku": "MMFC-1B",
      "title": "MiamiMD Facial Cleanser 1 Tube (Special)",
      "image": "assets/acfup-cleanser.png",
      "price": null,
      "catalogPriceCents": 2730,
      "catalogFamily": "special",
      "enabled": false,
      "fulfillmentVerified": false,
      "publicPlanReadbackVerified": false
    },
    {
      "handle": "miamimd-lip-plumper-1-bottle-special",
      "productId": 15485384884509,
      "variantId": 67912075903261,
      "sku": "MMLP-1B",
      "title": "MiamiMD Lip Plumper 1 Bottle (Special)",
      "image": "assets/acfup-lip.png",
      "price": null,
      "catalogPriceCents": 3300,
      "catalogFamily": "special",
      "enabled": false,
      "fulfillmentVerified": false,
      "publicPlanReadbackVerified": false
    },
    {
      "handle": "miamimd-dark-spot-corrector-1-bottle-special",
      "productId": 15485350543645,
      "variantId": 67911687602461,
      "sku": "MMDSC-1B",
      "title": "MiamiMD Dark Spot Corrector 1 Bottle (Special)",
      "image": "assets/acfup-dsc.png",
      "price": null,
      "catalogPriceCents": 3300,
      "catalogFamily": "special",
      "enabled": false,
      "fulfillmentVerified": false,
      "publicPlanReadbackVerified": false
    }
  ],
  "catalogRegistryVersion": "emanuel-catalog-20261029"
};
